import { RepositoryDocumentsPage } from "@/components/revenueos/RepositoryDocumentsPage";

export default function CommercialProposals() {
  return (
    <RepositoryDocumentsPage
      category="commercial_proposal"
      title="Commercial Proposals"
      description="Commercial proposal documents, shared across every partner and admin."
    />
  );
}
